import { ChangeDetectionStrategy, Component, Input, OnDestroy, forwardRef } from '@angular/core';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { SwiperModule } from 'swiper/angular';
import { ProductComponent } from '../../catalog/ui/product/product.component';
import { RelatedProductsComponent } from '../../catalog/ui/related-products/related-products.component';
import { GtmImpressionTrackDirective } from '../../module/gtm/gtm-impression-track.directive';
import { GtmTrackProductClickDirective } from '../../module/gtm/gtm-track-product-click.directive';
/**
 * Sample usage
 *
 * ```html
 *     <basket-related-products class="block m-t m-b-8"
 *          [source]="model"
 *          [options]="{limit: [2,3,4,4][app.client.sizeId], engines: 'category'}">
 *              You may also like
 *     </basket-related-products>
 * ```
 */
@Component({
    selector: 'basket-related-products',
    templateUrl: './basket-related-products.html',
    styleUrls: ['./basket-related-products.scss'],
    standalone: true,
    imports: [
        GtmImpressionTrackDirective,
        GtmTrackProductClickDirective,
        forwardRef(() => ProductComponent),
        SizeClassDirective,
        SwiperModule,
        TranslationModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketRelatedProductsComponent extends RelatedProductsComponent implements OnDestroy {
    @Input()
    title?: string;
}
